import type { NewsHeadline } from '../types'

/**
 * Outlets the Dashboard news ticker carries, by the name the backend's RSS
 * pipeline stores (NewsFeedService.rss_feeds). Mirrors TICKER_SOURCES in
 * backend/app/api/news_feeds.py.
 */
export const TICKER_SOURCES = ['CoinDesk', 'Cointelegraph', 'Bitcoin Magazine'] as const

const isWebLink = (url: unknown): url is string => typeof url === 'string' && /^https?:\/\//i.test(url)

/**
 * Feed articles fit for the ticker: from a carried outlet, with a title and a
 * web link (a feed's link becomes an href, so nothing like `javascript:`).
 * Only the feed's own fields pass through; no summary or other text.
 */
export const toTickerHeadlines = (articles: unknown): NewsHeadline[] => {
  if (!Array.isArray(articles)) return []
  const sources: readonly string[] = TICKER_SOURCES
  return articles
    .filter(
      (a): a is NewsHeadline =>
        a != null &&
        typeof a.title === 'string' &&
        a.title.trim() !== '' &&
        sources.includes(a.source) &&
        isWebLink(a.url)
    )
    .map(({ title, url, source, published_at, symbols }) => ({
      title,
      url,
      source,
      published_at,
      symbols: Array.isArray(symbols) ? symbols : [],
    }))
}
